export default {
    organizations: 'Working Groups',
    events: 'Events',
    projects: 'Projects',
    invitations: 'Invitations',
    notifications: 'Notifications',
    settings: 'Settings',
}
